/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_We_Work_Launch_Body_1Inputs */

const en_how_we_work_launch_body_1 = /** @type {(inputs: How_We_Work_Launch_Body_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start with the right people and a manageable scope. We show your team how to use the system, where to review its work and how to deal with an exception.`)
};

const lv_how_we_work_launch_body_1 = /** @type {(inputs: How_We_Work_Launch_Body_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sākam ar īstajiem cilvēkiem un pārskatāmu apjomu. Mēs parādām komandai, kā sistēmu lietot, kur pārskatīt tās darbu un kā rīkoties ar izņēmumu.`)
};

/**
* | output |
* | --- |
* | "Start with the right people and a manageable scope. We show your team how to use the system, where to review its work and how to deal with an exception." |
*
* @param {How_We_Work_Launch_Body_1Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const how_we_work_launch_body_1 = /** @type {((inputs?: How_We_Work_Launch_Body_1Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_We_Work_Launch_Body_1Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_how_we_work_launch_body_1(inputs)
	return en_how_we_work_launch_body_1(inputs)
});